export default "__VITE_ASSET__4HMsFUpA__"